export default {"src":"/_next/static/media/chevron-left.874d86f6.svg","height":20,"width":20};